<template>
  <div class="p-4 clickable" :style="{ borderBottom: '1px solid ' + theme.page_sidebar_border_color }" @click="onSelected">
    <div class="d-flex align-items-center">
      <div>
        <h6 class="m-0 font-weight-bold text-uppercase">
          {{ carrier.buyer.name }}
        </h6>

        <div class="small d-flex align-items-center">
          <i class="fas fa-map-marker" />
          <p v-if="carrier" class="m-0 ml-2 w-75">
            {{ carrier.ship_line_one.replace(".", "") }}
            {{ carrier.ship_line_two }}, {{ carrier.ship_city }}, {{ carrier.ship_state }},
            {{ carrier.ship_zip }}
          </p>
        </div>
      </div>
      <i class="fas fa-chevron-circle-right ml-auto" />
    </div>
    <BCollapse :visible="show" class="mt-3">
      <div class="d-flex justify-content-between align-items-center">
        <BushelBtn
          :style="{
            backgroundColor: theme.locator_directions_btn_color,
            color: theme.locator_directions_btn_text_color,
          }"
          class="btn-sm"
          @click="$emit('directions', carrier)"
        >
          <i class="fas fa-directions" /> Directions
        </BushelBtn>
        <BushelBtn
          v-if="carrier.buyer && carrier.buyer.website_url"
          :style="{
            backgroundColor: theme.locator_website_btn_color,
            color: theme.locator_website_btn_text_color,
          }"
          variant="success"
          class="btn-sm"
          @click="$emit('website', carrier)"
        >
          <i class="fas fa-link" /> Website
        </BushelBtn>
      </div>
    </BCollapse>
  </div>
</template>
<script>
import BCollapse from "@/components/base/BCollapse.vue";

export default {
  components: {
    BCollapse,
  },
  props: {
    carrier: { type: Object, required: true },
    theme: { type: Object },
  },
  emits: ["selected", "remove", "directions", "website"],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    onSelected() {
      this.show = !this.show;

      if (this.show) {
        this.$emit("selected", this.carrier.id);
      } else {
        this.$emit("remove", this.carrier.id);
      }
    },
  },
};
</script>
